import React from 'react';
import PropTypes from 'prop-types';
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";
import _ from "lodash";

import {translate as t} from "../../../lib/I18n";

import PassengerInfo from "../../fares/details/PassengerInfo";
import Price from "../../../components/general/Price";
import Icon from "../../../components/general/Icon";
import OnEnterTrigger from "../../../components/general/OnEnterTrigger";
import useSmartCarnetTicketDetails from "../../../hooks/useSmartCarnetTicketDetails";

const TicketCalculationsSummaryHeader = (
    {
        showRefundDetail,
        storedRefundCalculation,
        ticket,
        onClick,
        hasSmartCarnetTrip,
    }
) => {

    const { smartCarnetTicketDetails } = useSmartCarnetTicketDetails(ticket.id, hasSmartCarnetTrip);

    const ticketAdults = 1; // Override the ticket.adults = 5 as each ticket's pass is counted as 1 adult
    const ticketChildren = ticket.children;

    const smartCarnetTicketID = _.get(smartCarnetTicketDetails, 'ticketId');
    const remainingPassCount = _.get(smartCarnetTicketDetails, 'remainingPassCount');
    const initialPassCount = _.get(smartCarnetTicketDetails, 'initialPassCount');

    return (
        <OnEnterTrigger className="refund-ticket__header" onClick={ onClick }>
            <Row>
                <Col xs={ 6 } className="refund-ticket__header__title">
                    { t('booking.passengers.summary.text', {
                        adults: ticketAdults,
                        children: ticketChildren
                    }) }
                    {smartCarnetTicketID &&
                        <span>
                            - {t('smartCarnet.refund.numberOfPasses')} {remainingPassCount} / {initialPassCount}
                        </span>
                    }
                    {storedRefundCalculation && <div className="refund-ticket__header__date">
                        {t('account.orders.refund.itso.refundDate', { date: storedRefundCalculation.getRefundDate() })}</div>}
                    <PassengerInfo className="refund-ticket__header__passenger" ticket={ticket} />
                </Col>
                <Col xs={ 6 } className="refund-ticket__header__price text-weight--bold">
                    <Price price={ ticket.price } />
                </Col>
                <div className="refund-ticket__header__arrow">
                    <Icon icon="dropdown" className={ showRefundDetail ? "otrl-rotate-180" : '' } />
                </div>
            </Row>
        </OnEnterTrigger>
    );
};

TicketCalculationsSummaryHeader.propTypes = {
    showRefundDetail: PropTypes.any,
    storedRefundCalculation: PropTypes.any,
    ticket: PropTypes.any,
    onClick: PropTypes.any,
    hasSmartCarnetTrip: PropTypes.bool,
};

export default TicketCalculationsSummaryHeader;



// WEBPACK FOOTER //
// ./src/components/account/refund/TicketCalculationsSummaryHeader.js